export const notificationType = [
  { value: 'in_app', label: 'In App', icon: 'smartphone' },
  { value: 'sms', label: 'Sms', icon: 'message' },
  { value: 'push', label: 'Push', icon: 'push' },
]
